import React from 'react';
import PropTypes from 'prop-types';

const CriticalPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M14.283 3.321C14.756 2.451 15.38 2.02 16 2.02c.622 0 1.245.435 1.717 1.302L29.69 25.297c.814 1.494.093 2.706-1.6 2.706H3.91c-1.697 0-2.413-1.215-1.6-2.706L14.284 3.32zm.687 15.326c0 .569.461 1.033 1.03 1.033.573 0 1.03-.462 1.03-1.033l.645-7.466c.071-.932-.632-1.681-1.569-1.681h-.212c-.932 0-1.639.752-1.569 1.681l.645 7.466zM14.3 23c0 .943.757 1.7 1.7 1.7.942 0 1.7-.757 1.7-1.7 0-.942-.758-1.7-1.7-1.7-.943 0-1.7.758-1.7 1.7z"
    />
  );
};

CriticalPath.propTypes = {
  fill: PropTypes.string,
};

export default CriticalPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/feedback/critical.jsx